import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { B as Button } from '../../Button/Button-rs5QufkK.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { g as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { I as Icon } from '../../Icon/Icon-CqA2URu0.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';

const MenuButtonTriggerIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30061128__sc-uwares-0"
})(["margin-inline-start:10px;margin-inline-end:0;color:", ";", " pointer-events:none;"], ({
  $disabled,
  theme
}) => !$disabled ? theme.dropdown.icon.color : theme.dropdown.icon.colorDisabled, ({
  $primary,
  $disabled,
  theme
}) => $primary && `
    color: ${!$disabled ? theme.button.primary.color : theme.button.primary.colorDisabled};
  `);
MenuButtonTriggerIcon.displayName = 'MenuButtonTriggerIcon';
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30061128__sc-uwares-1"
})([""]);
const MenuButton = withTaktFallbackId(StyledButton);
const MenuButtonTrigger = /*#__PURE__*/forwardRef(({
  children,
  disabled,
  primary,
  ...rest
}, ref) => /*#__PURE__*/React__default.createElement(MenuButton, _extends({}, rest, {
  disabled: disabled,
  buttonRef: ref,
  primary: primary,
  taktFallbackId: createStormTaktId('menu-button')
}), children, /*#__PURE__*/React__default.createElement(MenuButtonTriggerIcon, {
  type: angleDown,
  $disabled: disabled,
  $primary: primary
})));

export { MenuButtonTrigger as M };
//# sourceMappingURL=MenuButtonTrigger-CUjlmhzX.js.map
